import React, { Component } from 'react';
import Fade from 'react-reveal';
import dash from './../../shared/assets/images/covid/wide-dash.png';
import { connect } from 'react-redux';
import lang from '../../lang/lang.json';
import './howToExam.scss';

class HowToExam extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onSelectCityHandler: '',
      isMobile: false,
      test: Math.random() * 10,
    };
  }
  componentDidMount() {
    if (window.innerWidth <= 768) {
      this.setState({
        isMobile: true,
      });
    }
  }

  componentWillReceiveProps(props) {
    this.setState({
      onSelectCityHandler: props.cityHandler,
    });
  }

  handelChange = (e) => {
    this.setState({ language: e.target.value });
  };

  render() {
    return (
      <div id="howToGet" style={{ marginTop: '100px' }}>
        <div
          className={
            this.state.isMobile ? 'how-to-get container' : 'how-to-get '
          }
        >
          <Fade bottom>
            <div className="how-to-get getMargin mobile-padding-center">
              <div
                className={
                  this.state.isMobile
                    ? 'mobile-padding-gap'
                    : 'container p-0 p-lg-3'
                }
              >
                <div className="row">
                  <div className="col-lg-8 col-md-12 col-sm-12">
                    <h4 className="how-to-get-header">
                      {lang.WHAT_DOC_NEED_TITLE[this.props.language]}
                    </h4>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-4 d-flex col-md-6 mb-md-3 pr-0 mb-sm-5 col-sm-12">
                    <img src={dash} alt="dash" className="green-dash" />
                    <div className="svg-layer">
                      <div className="text-padding subTitle">
                        <h3 className="sub-title mt-lg-3">
                          {
                            lang.WHAT_DOC_NEED_REASON_1_TITLE[
                              this.props.language
                            ]
                          }
                        </h3>
                        <div style={{ opacity: 0.8 }}>
                          {lang.WHAT_DOC_NEED_REASON_1_1[this.props.language]}
                          <br className="d-none d-md-block" />
                          {lang.WHAT_DOC_NEED_REASON_1_2[this.props.language]}
                          <br className="d-none d-md-block" />
                          {lang.WHAT_DOC_NEED_REASON_1_3[this.props.language]}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 d-flex col-md-6 mb-md-3 pr-0 mb-sm-5 col-sm-12  margin-top-line">
                    <img src={dash} alt="dash" className="green-dash" />
                    <div className="svg-layer">
                      <div className="text-padding subTitle">
                        <h3 className="sub-title mt-lg-3">
                          {
                            lang.WHAT_DOC_NEED_REASON_2_TITLE[
                              this.props.language
                            ]
                          }
                        </h3>
                        <div style={{ opacity: 0.8 }}>
                          {lang.WHAT_DOC_NEED_REASON_2_1[this.props.language]}
                          <br className="d-none d-md-block" />
                          {lang.WHAT_DOC_NEED_REASON_2_2[this.props.language]}
                          <br className="d-none d-md-block" />
                          {lang.WHAT_DOC_NEED_REASON_2_3[this.props.language]}
                          <br className="d-none d-md-block" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 d-flex col-md-6 mb-md-3 pr-0 mb-sm-5 col-sm-12 margin-top-line">
                    <img src={dash} alt="dash" className="green-dash" />
                    <div className="svg-layer">
                      <div className="text-padding subTitle">
                        <h3 className="sub-title mt-lg-3">
                          {
                            lang.WHAT_DOC_NEED_REASON_3_TITLE[
                              this.props.language
                            ]
                          }
                        </h3>
                        <div style={{ opacity: 0.8 }}>
                          {lang.WHAT_DOC_NEED_REASON_3_1[this.props.language]}
                          <br className="d-none d-md-block" />
                          {lang.WHAT_DOC_NEED_REASON_3_2[this.props.language]}
                          <br className="d-none d-md-block" />
                          {lang.WHAT_DOC_NEED_REASON_3_3[this.props.language]}
                          <br className="d-none d-md-block" />
                          {lang.WHAT_DOC_NEED_REASON_3_4[this.props.language]}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-4 d-flex col-md-6 mb-md-3 pr-0 mb-sm-5 col-sm-12 margin-top-line">
                    <img src={dash} alt="dash" className="green-dash" />
                    <div className="svg-layer">
                      <div className="text-padding subTitle">
                        <h3 className="sub-title mt-lg-3">
                          {
                            lang.WHAT_DOC_NEED_REASON_4_TITLE[
                              this.props.language
                            ]
                          }
                        </h3>
                        <div style={{ opacity: 0.8 }}>
                          {lang.WHAT_DOC_NEED_REASON_4_1[this.props.language]}
                          <br className="d-none d-md-block" />
                          {lang.WHAT_DOC_NEED_REASON_4_2[this.props.language]}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4  d-flex col-md-6 mb-md-3 pr-0 mb-sm-5 col-sm-12 margin-top-line">
                    <img src={dash} alt="dash" className="green-dash" />
                    <div className="svg-layer">
                      <div className="text-padding subTitle">
                        <h3 className="sub-title mt-lg-3">
                          {
                            lang.WHAT_DOC_NEED_REASON_5_TITLE[
                              this.props.language
                            ]
                          }
                        </h3>
                        <div style={{ opacity: 0.8 }}>
                          {lang.WHAT_DOC_NEED_REASON_5_1[this.props.language]}
                          <br className="d-none d-md-block" />
                          {lang.WHAT_DOC_NEED_REASON_5_2[this.props.language]}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Fade>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language.language,
  };
}

export default connect(mapStateToProps)(HowToExam);
